import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { useNavigate, useParams } from 'react-router-dom';
import { Rating, Typography } from '@mui/material';

import OverallAllocation from './OverallAllocation';
import AllocationResources from './AllocationResources';
import AvailableResources from './AvailableResources';
import { getSingleSkill } from 'src/services/skillManagementService';
import { Resource, Skill } from 'src/models/Skills';
import { useEffect, useState } from 'react';

const SingleSkillView = () => {

  const { skillName } = useParams();
  const navigate = useNavigate();
  
  const initalAllocatedResourcesList: Resource[] = [];
  const [allocatedResources, setAllocatedResources] = useState(initalAllocatedResourcesList)

  const initalAvailableResourcesList: Resource[] = [];
  const [availableResources, setAvailableResources] = useState(initalAvailableResourcesList)

  const getSingleSkillDetails = (name) => {
    getSingleSkill({
      "skills": {
        "skill1": name
      }
    }).then((res) => {
        var x : Skill[] = res.data;
        x.forEach((item) => {
          if(item.allocatedResources !== undefined || item.allocatedResources !== null){
            setAllocatedResources(item.allocatedResources); 
          }

          if(item.availableResources !== undefined || item.availableResources !== null){
            setAvailableResources(item.availableResources); 
          }
        });
    });
  }

  useEffect(() => {
    getSingleSkillDetails(skillName);
  }, []);

  return (
    <>
      <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
        <Grid item>
          <Typography
            style={{
              marginLeft: '0px',
              fontWeight: '700',
              fontSize: '16px',
              fontFamily:
                'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
            }}
          >
            <span style={{cursor: 'pointer'}} onClick={() => {
              navigate('/skills');
            }}>Skills</span> / {skillName}
          </Typography>
          <Typography variant="subtitle2"></Typography>
        </Grid>
      </Grid>
    <Grid container spacing={3}>
        
        <Grid item xs>
          <OverallAllocation allocatedResoureCount={allocatedResources.length}
            availableResoureCount={availableResources.length}
          />
        </Grid>

        <Grid item xs>
          <AllocationResources resources={allocatedResources}  />
        </Grid>

        <Grid item xs>
          <AvailableResources skillName='name' resources={availableResources}/>
        </Grid>
    </Grid>
    </>
  );
};

export default SingleSkillView;
